// Module
var code = "<!doctype html> <html> <body> <div> <h1>404</h1> <h2>PAGE NOT FOUND</h2> <p> Sorry, the page you're looking for doesn't exist. <a href=\"javascript:void(0)\" onclick=\"history.back()\">Go Back</a> </p> </div> </body> </html> ";
// Exports
module.exports = code;